<template>
  <div>
    <portal to="page-top-title">Edit Api Provider #{{ id }}</portal>
    <portal to="page-top-right">
      <btn :route="{ name: 'apis-providers-single', params: { id: id } }" icon="fa-eye" text>Back to Provider</btn>
    </portal>

    <box-form action="edit" data-prop="formData" redirect="apis-providers-list"
              :url="`/apis/providers/${id}`" :loaded="loaded" loader>
      <template slot="content">
        <row>
          <column-input>
            <form-group-input name="name" :model="formData.name" :min="3" required/>
          </column-input>
          <column-input :md="2">
            <form-group-check name="active" :model="formData.active"/>
          </column-input>
        </row>
      </template>
    </box-form>
  </div>
</template>

<script>
import BoxForm from '@/views/components/data/BoxForm'
import Btn from '@/views/components/simple/Btn'
import FormGroupInput from '@/views/components/form/FormGroupInput'
import FormGroupCheck from '@/views/components/form/FormGroupCheck'
import Form from '@/modules/utils/Form'

export default {
  name: 'ApisProvidersEdit',
  metaInfo () {
    return { title: `Apis | Provider #${this.id} | Edit` }
  },
  components: {
    BoxForm,
    Btn,
    FormGroupInput,
    FormGroupCheck
  },
  computed: {
    id () { return this.$route.params.id }
  },
  data () {
    return {
      loaded: false,
      formData: {
        name: Form.types.input(),
        active: Form.types.boolean()
      }
    }
  },
  created () {
    this.loadEntity()
  },
  methods: {
    loadEntity () {
      this.$http
        .get(`/apis/providers/${this.id}`)
        .then((res) => {
          const { data: { data } } = res

          this.formData.name.value = data.name
          this.formData.active.value = data.active

          this.loaded = true
        })
    }
  }
}
</script>
